webpackJsonp([114276838955818,60335399758886],{

/***/ 112:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Daresay News"}}},"layoutContext":{}}

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(244);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(112);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(333);
	var isArguments = __webpack_require__(332);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(480);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(331);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(460);
	
	var _HelmetConstants = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(340));
	var shallowEqual = _interopDefault(__webpack_require__(497));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 497:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.DissapearLeft = exports.AppearRight = exports.BounceIn = undefined;
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BounceIn = exports.BounceIn = (0, _styledComponents.keyframes)(["0%{opacity:0;transform:translateY(16px) scale(0.3);}40%{transform:translateY(-2px) scale(1.1);}100%{opacity:1;transform:translateY(0px) scale(1);}"]);
	
	var AppearRight = exports.AppearRight = (0, _styledComponents.keyframes)(["0%{opacity:0;transform:translateX(16px);}100%{opacity:1;transform:translateX(0px);}"]);
	
	var DissapearLeft = exports.DissapearLeft = (0, _styledComponents.keyframes)(["0%{transform:translateX(0px) translateY(0) scale(1);}100%{opacity:0.5;transform:translateX(32px) translateY(12px) scale(0.3);}"]);

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hamburger = __webpack_require__(236);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FabComponent = _styledComponents2.default.div.withConfig({
	  displayName: 'fabButton__FabComponent'
	})(['position:fixed;width:64px;height:64px;border-radius:50%;background:', ';;bottom:0;right:0;margin:16px;box-shadow:0 4px 24px rgba(0,0,0,0.16);transition:all .5s ease;&:hover{cursor:pointer;}'], function (props) {
	  return props.isActive ? '#EB3D35' : '#fff';
	});
	
	var FabButton = function FabButton(props) {
	  return _react2.default.createElement(
	    FabComponent,
	    { onClick: props.toggleFab, isActive: props.isActive },
	    _react2.default.createElement(_hamburger2.default, { isActive: props.isActive })
	  );
	};
	
	exports.default = FabButton;
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BurgerWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'hamburger__BurgerWrapper'
	})(['display:flex;flex-direction:column;justify-content:center;height:100%;margin:auto;']);
	
	var Burger = _styledComponents2.default.div.withConfig({
	  displayName: 'hamburger__Burger'
	})(['width:28px;height:2px;position:relative;margin:0 auto;background:', ';transition:all 0ms .2s;&:before{content:"";width:28px;height:2px;position:absolute;left:0;bottom:', ';transform:', ';background:', ';transition:', ';}&:after{content:"";width:28px;height:2px;position:absolute;left:0;top:', ';transform:', ';background:', ';transition:', ';}'], function (props) {
	  return props.isActive ? '#EB3D35' : '#141419';
	}, function (props) {
	  return props.isActive ? '0' : '8px';
	}, function (props) {
	  return props.isActive ? 'rotate(-45deg)' : 'rotate(0)';
	}, function (props) {
	  return props.isActive ? '#fff' : '#141419';
	}, function (props) {
	  return props.isActive ? 'all .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s .2s cubic-bezier(0.23, 1, 0.32, 1)' : 'all .2s .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s cubic-bezier(0.23, 1, 0.32, 1)';
	}, function (props) {
	  return props.isActive ? '0' : '8px';
	}, function (props) {
	  return props.isActive ? 'rotate(45deg)' : 'rotate(0)';
	}, function (props) {
	  return props.isActive ? '#fff' : '#141419';
	}, function (props) {
	  return props.isActive ? 'all .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s .2s cubic-bezier(0.23, 1, 0.32, 1)' : 'all .2s .2s cubic-bezier(0.23, 1, 0.32, 1), transform .2s cubic-bezier(0.23, 1, 0.32, 1)';
	});
	
	var Hamburger = function Hamburger(_ref) {
	  var isActive = _ref.isActive;
	  return _react2.default.createElement(
	    BurgerWrapper,
	    null,
	    _react2.default.createElement(Burger, { isActive: isActive })
	  );
	};
	
	exports.default = Hamburger;
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _fabButton = __webpack_require__(235);
	
	var _fabButton2 = _interopRequireDefault(_fabButton);
	
	var _linksWrapper = __webpack_require__(238);
	
	var _linksWrapper2 = _interopRequireDefault(_linksWrapper);
	
	var _animations = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FabWrapper = _styledComponents2.default.nav.withConfig({
	  displayName: 'MobNav__FabWrapper'
	})(['position:fixed;z-index:100;width:', ';height:100%;bottom:0;right:0;background:#111;box-shadow:0 4px 24px rgba(0,0,0,0.16);transition:all .3s ease;'], function (props) {
	  return props.isActive ? '75%' : '0';
	});
	
	var MobNav = function (_React$Component) {
	  _inherits(MobNav, _React$Component);
	
	  function MobNav(props) {
	    _classCallCheck(this, MobNav);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggleFab = function () {
	      _this.setState({
	        fabIsActive: !_this.state.fabIsActive
	      });
	    };
	
	    _this.itemSelected = function () {
	      setTimeout(function () {
	        _this.setState({ fabIsActive: false });
	      }, 500);
	    };
	
	    _this.state = {
	      fabIsActive: false
	    };
	    return _this;
	  }
	
	  MobNav.prototype.render = function render() {
	    return _react2.default.createElement(
	      FabWrapper,
	      { isActive: this.state.fabIsActive },
	      _react2.default.createElement(_fabButton2.default, { toggleFab: this.toggleFab, isActive: this.state.fabIsActive }),
	      _react2.default.createElement(_linksWrapper2.default, { handleItem: this.itemSelected, isActive: this.state.fabIsActive })
	    );
	  };
	
	  return MobNav;
	}(_react2.default.Component);
	
	exports.default = MobNav;
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _animations = __webpack_require__(82);
	
	var _navData = __webpack_require__(140);
	
	var _navLink = __webpack_require__(239);
	
	var _navLink2 = _interopRequireDefault(_navLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'linksWrapper__LinkWrapper'
	})(['display:', ';flex-direction:column;position:fixed;bottom:88px;right:16px;transition:all .3s ease;.title{font-size:34px;font-family:Space Mono,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";font-weight:bold;margin:16px;text-align:right;color:#fff;animation:', '}'], function (props) {
	  return props.isActive ? 'flex' : 'none';
	}, function (props) {
	  return props.isActive ? _animations.AppearRight + ' .8s' : '';
	});
	
	var LinksWrapper = function LinksWrapper(_ref) {
	  var handleItem = _ref.handleItem,
	      isActive = _ref.isActive;
	  return _react2.default.createElement(
	    LinkWrapper,
	    { isActive: isActive },
	    _react2.default.createElement(
	      'h1',
	      { className: 'title' },
	      'MENU'
	    ),
	    _navData.navData.map(function (obj, i) {
	      return _react2.default.createElement(_navLink2.default, { key: i, delay: i, handleItem: handleItem, title: obj.title, image: obj.image, href: obj.href });
	    })
	  );
	};
	
	exports.default = LinksWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _animations = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkItem = _styledComponents2.default.div.withConfig({
	  displayName: 'navLink__LinkItem'
	})(['text-decoration:none;display:flex;flex-direction:row;align-items:center;justify-content:flex-end;margin:6px 0;color:#fff;font-size:11px;.sourceLogo{width:32px;height:32px;border-radius:50%;margin-right:16px;margin-left:12px;opacity:0;animation:', ';animation-delay:', 's;animation-fill-mode:forwards;}.link{opacity:0;animation:', ';animation-delay:', 's;animation-fill-mode:forwards;}'], function (props) {
	  return props.isActive ? '' : _animations.BounceIn + ' .8s';
	}, function (props) {
	  return 0.3 - props.delay / 20;
	}, function (props) {
	  return props.isActive ? '' : _animations.AppearRight + ' .8s';
	}, function (props) {
	  return 0.3 - props.delay / 20;
	});
	
	var NavLink = function NavLink(_ref) {
	  var handleItem = _ref.handleItem,
	      isActive = _ref.isActive,
	      delay = _ref.delay,
	      href = _ref.href,
	      title = _ref.title,
	      image = _ref.image;
	
	
	  var link__itemActive = {
	    background: '#fff',
	    color: '#000',
	    padding: '4px 12px',
	    borderRadius: '16px',
	    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.16)',
	    transition: 'all .3s ease'
	  };
	
	  var link__item = {
	    textDecoration: 'none',
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center',
	    justifyContent: 'flex-end',
	    margin: '8px 0',
	    padding: '4px 0',
	    color: '#fff',
	    fontSize: '16px',
	    lineHeight: '20px',
	    transition: 'all .3s ease'
	  };
	
	  return _react2.default.createElement(
	    LinkItem,
	    { onClick: handleItem, delay: delay },
	    _react2.default.createElement(
	      'span',
	      { className: 'link' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: link__item, activeStyle: link__itemActive, exact: true, to: href },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: href },
	      _react2.default.createElement('img', { className: 'sourceLogo', src: image })
	    )
	  );
	};
	
	exports.default = NavLink;
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _navData = __webpack_require__(140);
	
	var _logo = __webpack_require__(242);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _navLink = __webpack_require__(241);
	
	var _navLink2 = _interopRequireDefault(_navLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarWrapper = _styledComponents2.default.nav.withConfig({
	  displayName: 'deskNav__SidebarWrapper'
	})(['height:100vh;display:flex;position:fixed;width:300px;flex-direction:column;align-items:center;box-shadow:0 4px 34px rgba(0,0,0,0.08);']);
	
	// import copycat_x24 from '../../static/copycat_x24.svg';
	// import producthunt_logo from '../../static/producthunt_logo.svg';
	// import verge_logo from '../../static/verge_logo.svg';
	// import reddit_logo from '../../static/reddit.svg';
	// import designernews_logo from '../../static/designernews_logo.svg';
	
	
	var LogoWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'deskNav__LogoWrapper'
	})(['display:flex;justify-content:center;margin-bottom:16px;width:100%;background:#141419;height:200px;']);
	
	var LinksWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'deskNav__LinksWrapper'
	})(['display:flex;flex-direction:column;width:100%;height:100%;.navDesc{margin:8px 0;padding:8px 40px;color:#141419;opacity:0.4;font-weight:200;}.source__logo{width:32px;height:32px;border-radius:50%;margin-right:16px;}']);
	
	var InfoWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'deskNav__InfoWrapper'
	})(['display:flex;justify-content:flex-end;padding:8px 40px;margin-bottom:128px;width:100%;.info-text{font-size:12px;}']);
	
	var DeskNav = function DeskNav(_ref) {
	  var siteTitle = _ref.siteTitle;
	
	
	  var link__itemActive = {
	    background: '#fbfbfb',
	    color: '#141419',
	    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.14)',
	    width: '85%',
	    borderRadius: '0 50px 50px 0',
	    fontWeight: '700',
	    transition: 'all .2s ease'
	  };
	
	  var link__item = {
	    textDecoration: 'none',
	    display: 'flex',
	    alignItems: 'center',
	    margin: '8px 0',
	    padding: '8px 40px',
	    width: '85%',
	    borderRadius: '0 50px 50px 0',
	    color: '#888',
	    fontSize: '14px',
	    transition: 'all .2s ease'
	  };
	
	  return _react2.default.createElement(
	    SidebarWrapper,
	    null,
	    _react2.default.createElement(
	      LogoWrapper,
	      null,
	      _react2.default.createElement(_logo2.default, null)
	    ),
	    _react2.default.createElement(
	      LinksWrapper,
	      null,
	      _react2.default.createElement(_navLink2.default, { title: _navData.navData[0].title, image: _navData.navData[0].image, href: _navData.navData[0].href }),
	      _react2.default.createElement(
	        'p',
	        { className: 'navDesc' },
	        'Categories'
	      ),
	      _navData.navData.map(function (obj, i) {
	        return i !== 0 && _react2.default.createElement(_navLink2.default, { key: i, title: obj.title, image: obj.image, href: obj.href });
	      })
	    ),
	    _react2.default.createElement(
	      InfoWrapper,
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: 'info-text' },
	        'This newsreader was created during Daresay Summer Camp 2018.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        ' For feedback, questions, and new ideas please contact mikael.skoglund@daresay.co'
	      )
	    )
	  );
	};
	
	exports.default = DeskNav;
	module.exports = exports['default'];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = function NavLink(_ref) {
	  var title = _ref.title,
	      image = _ref.image,
	      href = _ref.href;
	
	
	  var link__itemActive = {
	    background: '#fbfbfb',
	    color: '#000',
	    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.14)',
	    width: '85%',
	    borderRadius: '0 50px 50px 0',
	    fontWeight: '700',
	    transition: 'all .2s ease'
	  };
	
	  var link__item = {
	    textDecoration: 'none',
	    display: 'flex',
	    alignItems: 'center',
	    margin: '8px 0',
	    padding: '8px 40px',
	    width: '85%',
	    borderRadius: '0 50px 50px 0',
	    color: '#888',
	    fontSize: '14px',
	    transition: 'all .2s ease'
	  };
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { style: link__item, activeStyle: link__itemActive, exact: true, to: href },
	    _react2.default.createElement('img', { className: 'source__logo', src: image }),
	    title
	  )
	  // <p className="navDesc">Sources</p>
	  ;
	};
	
	exports.default = NavLink;
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = function (_React$PureComponent) {
	  _inherits(Logo, _React$PureComponent);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Logo.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "logo-wrapper" },
	      _react2.default.createElement(
	        "svg",
	        { xmlns: "http://www.w3.org/2000/svg", width: "173", height: "62", viewBox: "0 0 173 62" },
	        _react2.default.createElement("path", { d: "M0 .350082762L6.35150154.350082762C8.51869138.350082762 10.1273889.854363602 11.1776425 1.86294041 12.227896 2.87151722 12.7530149 4.43437106    12.7530149 6.55154883L12.7530149 11.6527548C12.7530149 13.7699326 12.227896 15.3327864 11.1776425 16.3413632 10.1273889 17.34994 8.51869138 17.8542209    6.35150154 17.8542209L0 17.8542209 0 14.6784701 1.65039016 14.6784701 1.65039016 3.50082762 0 3.50082762 0 .350082762zM6.35150154 14.703476C7.50177922   14.703476 8.306128 14.4325813 8.764572 13.8907839 9.22301601 13.3489864 9.45223457 12.5029615 9.45223457 11.3526838L9.45223457 6.55154883C9.45223457     5.55130737 9.22301601 4.7928023 8.764572 4.27601088 8.306128 3.75921945 7.50177922 3.50082762 6.35150154 3.50082762L4.95117049 3.50082762 4.95117049    14.703476 6.35150154 14.703476zM24.7808584 14.1033341L18.8294514 14.1033341 17.9792504 17.8542209 14.5284346 17.8542209 18.7044218.350082762    24.9058879.350082762 29.0818751 17.8542209 25.6310594 17.8542209 24.7808584 14.1033341zM19.5296169 10.9525893L24.0556869 10.9525893 22.0302081   2.00047293 21.5801017 2.00047293 19.5296169 10.9525893zM43.0351738 17.8542209L39.7343935 17.8542209 39.7343935 12.6029794C39.7343935 12.2028828    39.6302032 11.8778092 39.4218196 11.6277489 39.2134359 11.3776885 38.8675243 11.2526602 38.3840742 11.2526602L34.5831757 11.2526602 34.5831757    17.8542209 31.2823954 17.8542209 31.2823954.350082762 37.9839797.350082762C38.884197.350082762 39.6760429.475111069 40.3595413.725171435   41.0430396.975231801 41.6140022 1.32114345 42.0724462 1.76291677 42.5308902 2.20469008 42.8809695 2.71730614 43.1226945 3.30078033 43.3644195    3.88425451 43.4852802 4.50939605 43.4852802 5.17622369L43.4852802 5.77636557C43.4852802 6.49320529 43.2935701 7.16419054 42.9101442 7.78934145    42.5267183 8.41449237 41.9349177 8.89376755 41.1347245 9.22718137L41.1347245 9.67728777C41.7181987 9.74397054 42.1808034 9.96902149 42.5225526   10.3524474 42.8643018 10.7358733 43.0351738 11.2193161 43.0351738 11.8027903L43.0351738 17.8542209zM34.5831757 8.10191535L37.7339205     8.10191535C38.5341137 8.10191535 39.1425848 7.91437289 39.5593521 7.53928234 39.9761194 7.16419179 40.1844999 6.63490529 40.1844999     5.95140695L40.1844999 5.65133601C40.1844999 5.06786183 39.9761194 4.56358099 39.5593521 4.13847836 39.1425848 3.71337574 38.5341137 3.50082762    37.7339205 3.50082762L34.5831757 3.50082762 34.5831757 8.10191535zM46.8110664.350082762L57.8636794.350082762 57.8636794 3.50082762 50.1118468   3.50082762 50.1118468 7.50177347 57.5636084 7.50177347 57.5636084 10.6525183 50.1118468 10.6525183 50.1118468 14.703476 58.1637503 14.703476 58.1637503    17.8542209 46.8110664 17.8542209 46.8110664.350082762zM70.7167179 5.70134784C70.7167179 5.00117881 70.4458232 4.39270772 69.9040258 3.87591629    69.3622283 3.35912487 68.5995556 3.10073303 67.6159849 3.10073303 66.7824503 3.10073303 66.1239679 3.27160505 65.6405179 3.61335422 65.1570678   3.95510339 64.9153464 4.41770813 64.9153464 5.00118231 64.9153464 5.30125475 64.973693 5.57214942 65.0903878 5.81387444 65.2070826 6.05559946    65.4112955 6.27231519 65.7030326 6.46402814 65.9947697 6.65574109 66.3781899 6.82661311 66.8533046 6.97664933 67.3284193 7.12668555 67.9327227    7.26838429 68.6662332 7.40174982 70.5000092 7.73516364 71.9003262 8.29362342 72.8672263 9.0771459 73.8341264 9.86066838 74.3175692 11.019264 74.3175692    12.5529676L74.3175692 12.8530385C74.3175692 13.6699024 74.1717028 14.4075694 73.8799657 15.0660617 73.5882286 15.724554 73.1673 16.2871814 72.6171672    16.7539607 72.0670344 17.2207401 71.4002167 17.5791546 70.6166943 17.8292149 69.8331718 18.0792753 68.9496384 18.2043036 67.9660676 18.2043036   66.8157899 18.2043036 65.8030607 18.0417668 64.9278494 17.7166883 64.0526381 17.3916099 63.3233063 16.941508 62.7398321 16.3663691 62.1563579    15.7912303 61.7145912 15.1160774 61.4145188 14.3408903 61.1144464 13.5657031 60.9644124 12.7196783 60.9644124 11.8027903L60.9644124 11.0526129    64.2651927 11.0526129 64.2651927 11.6527548C64.2651927 12.7030083 64.5694283 13.540698 65.1779085 14.1658489 65.7863887 14.7909998 66.7324362    15.1035706 68.0160795 15.1035706 69.0163209 15.1035706 69.7581555 14.8868549 70.2416056 14.4534169 70.7250556 14.0199789 70.966777 13.5031952 70.966777    12.9030504 70.966777 12.6196486 70.9167657 12.348754 70.8167415 12.0903582 70.7167174 11.8319625 70.5416778 11.5985764 70.2916174 11.3901927 70.041557   11.1818091 69.699813 10.9942666 69.266375 10.8275597 68.8329371 10.6608528 68.2828125 10.519154 67.6159849 10.4024592 66.7324382 10.252423 65.9239219    10.0565453 65.1904114 9.81482029 64.456901 9.57309527 63.8192567 9.25218928 63.2774592 8.85209269 62.7356618 8.45199611 62.3147331 7.95188288   62.0146607 7.351738 61.7145882 6.75159312 61.5645543 6.01809372 61.5645543 5.15121778L61.5645543 5.00118231C61.5645543 4.2843426 61.7104206 3.62169257     62.0021577 3.01321234 62.2938948 2.40473212 62.7023206 1.87544562 63.2274474 1.42533696 63.7525742.9752283 64.3860509.625149039 65.1278967.375088673    65.8697424.125028308 66.6990969 0 67.6159849 0 68.6495677 0 69.566442.145866359 70.3666351.437603452 71.1668283.729340546 71.8378136 1.12526352   72.379611 1.62538425 72.9214085 2.12550498 73.3298343 2.7006352 73.6049007 3.35079215 73.8799671 4.0009491 74.0174982 4.68443718 74.0174982    5.4012769L74.0174982 6.30148971 70.7167179 6.30148971 70.7167179 5.70134784zM85.9953299 14.1033341L80.0439229 14.1033341 79.1937219 17.8542209    75.7429061 17.8542209 79.9188934.350082762 86.1203594.350082762 90.2963467 17.8542209 86.8455309 17.8542209 85.9953299 14.1033341zM80.7440884    10.9525893L85.2701584 10.9525893 83.2446796 2.00047293 82.7945732 2.00047293 80.7440884 10.9525893zM96.6728541 11.7027666L95.9226768 11.7027666    90.8964885.350082762 94.4973398.350082762 98.0981911 8.70205722 98.5482975 8.70205722 102.149149.350082762 105.75.350082762 100.723812 11.7027666    99.9736344 11.7027666 99.9736344 17.8542209 96.6728541 17.8542209 96.6728541 11.7027666zM114.3 17.5C114.099999 17.5 114 17.400001 114 17.2L114   4.525C114 4.34166575 114.083332 4.25 114.25 4.25L115.325 4.25C115.491667 4.25 115.575 4.3333325 115.575 4.5L115.575 5.975C115.575 6.175001 115.649999    6.20000075 115.8 6.05 116.800005 5.316663 117.629163 4.79166825 118.2875 4.475 118.945837 4.15833175 119.683329 4 120.5 4 121.78334 4 122.774996    4.33749662 123.475 5.0125 124.175004 5.68750338 124.525 6.591661 124.525 7.725L124.525 17.175C124.525 17.3916678 124.425001 17.5 124.225 17.5L123.175    17.5C122.974999 17.5 122.875 17.400001 122.875 17.2L122.875 8.175C122.875 6.308324 121.950009 5.375 120.1 5.375 119.333329 5.375 118.637503 5.53333175   118.0125 5.85 117.387497 6.16666825 116.600005 6.71666275 115.65 7.5L115.65 17.2C115.65 17.400001 115.541668 17.5 115.325 17.5L114.3 17.5zM129.425     11.625C129.425 12.4750042 129.633331 13.2708296 130.05 14.0125 130.466669 14.7541704 131.029163 15.3416645 131.7375 15.775 132.445837 16.2083355    133.216662 16.425 134.05 16.425 135.850009 16.425 137.216662 15.7000072 138.15 14.25 138.2 14.1666662 138.25 14.1208334 138.3 14.1125 138.35 14.1041666   138.408333 14.1166665 138.475 14.15L139.325 14.625C139.375 14.6583335 139.404167 14.6999998 139.4125 14.75 139.420833 14.8000002 139.4 14.858333 139.35    14.925 138.73333 15.8916715 137.983338 16.6041644 137.1 17.0625 136.216662 17.5208356 135.166673 17.75 133.95 17.75 132.733327 17.75 131.654171   17.4666695 130.7125 16.9 129.770829 16.3333305 129.033336 15.5375051 128.5 14.5125 127.966664 13.4874949 127.7 12.3166733 127.7 11 127.7 9.58332625    127.970831 8.34583862 128.5125 7.2875 129.054169 6.22916137 129.795829 5.4166695 130.7375 4.85 131.679171 4.2833305 132.741661 4 133.925 4 135.741676 4   137.179161 4.59582737 138.2375 5.7875 139.295839 6.97917262 139.825 8.6249895 139.825 10.725L139.825 10.875C139.825 10.9916672 139.804167 11.083333    139.7625 11.15 139.720833 11.216667 139.625001 11.25 139.475 11.25L129.6 11.25C129.483333 11.25 129.425 11.3749987 129.425 11.625zM137.725    10.075C137.891667 10.075 138.004166 10.0500002 138.0625 10 138.120834 9.94999975 138.15 9.858334 138.15 9.725 138.15 8.924996 137.979168 8.18333675    137.6375 7.5 137.295832 6.81666325 136.808336 6.275002 136.175 5.875 135.541663 5.474998 134.800004 5.275 133.95 5.275 133.016662 5.275 132.208337   5.50416438 131.525 5.9625 130.841663 6.42083562 130.320835 7.016663 129.9625 7.75 129.604165 8.483337 129.433333 9.25832925 129.45 10.075L137.725    10.075zM159.625 4.25C159.708334 4.25 159.775 4.27916637 159.825 4.3375 159.875 4.39583363 159.883333 4.46666625 159.85 4.55L156.075 17.2C156.025    17.400001 155.883334 17.5 155.65 17.5L154.65 17.5C154.383332 17.5 154.216667 17.400001 154.15 17.2L150.975 7.225C150.925 7.07499925 150.875 7 150.825 7    150.791666 7 150.75 7.07499925 150.7 7.225L147.675 17.2C147.625 17.400001 147.483334 17.5 147.25 17.5L146.2 17.5C145.916665 17.5 145.75 17.400001 145.7    17.2L141.775 4.575 141.75 4.475C141.75 4.408333 141.775 4.35416687 141.825 4.3125 141.875 4.27083313 141.941666 4.25 142.025 4.25L143.125    4.25C143.308334 4.25 143.425 4.3333325 143.475 4.5L146.675 14.9C146.725 15.0666675 146.783333 15.15 146.85 15.15 146.916667 15.15 146.975 15.0583343   147.025 14.875L150.175 4.45C150.225 4.316666 150.333332 4.25 150.5 4.25L151.425 4.25C151.608334 4.25 151.725 4.3333325 151.775 4.5L155.075 14.9C155.125    15.0666675 155.183333 15.15 155.25 15.15 155.316667 15.15 155.375 15.0583343 155.425 14.875L158.475 4.475C158.558334 4.32499925 158.683333 4.25 158.85    4.25L159.625 4.25zM170.675 7.05C170.308331 6.49999725 169.80417 6.06666825 169.1625 5.75 168.52083 5.43333175 167.783338 5.275 166.95 5.275 165.966662   5.275 165.158336 5.48333125 164.525 5.9 163.891663 6.31666875 163.575 6.8749965 163.575 7.575 163.575 7.99166875 163.737498 8.37083162 164.0625 8.7125     164.387502 9.05416838 164.958329 9.34999875 165.775 9.6L169.025 10.6C170.075005 10.9000015 170.858331 11.3374971 171.375 11.9125 171.891669 12.4875029    172.15 13.1666628 172.15 13.95 172.15 14.683337 171.920836 15.3374971 171.4625 15.9125 171.004164 16.4875029 170.375004 16.9374984 169.575 17.2625    168.774996 17.5875016 167.875005 17.75 166.875 17.75 165.624994 17.75 164.508338 17.4958359 163.525 16.9875 162.541662 16.4791641 161.841669 15.8083375    161.425 14.975 161.391666 14.908333 161.375 14.8583335 161.375 14.825 161.375 14.758333 161.408333 14.7000003 161.475 14.65L162.275 14.175C162.341667    14.1416665 162.391666 14.125 162.425 14.125 162.475 14.125 162.533333 14.158333 162.6 14.225 163.516671 15.7083407 164.92499 16.45 166.825 16.45   167.891672 16.45 168.779163 16.2375021 169.4875 15.8125 170.195837 15.3874979 170.55 14.8250035 170.55 14.125 170.55 13.6249975 170.341669 13.1958351    169.925 12.8375 169.508331 12.4791649 168.825005 12.166668 167.875 11.9L165.325 11.15C164.124994 10.816665 163.270836 10.3791694 162.7625 9.8375    162.254164 9.29583063 162 8.6416705 162 7.875 162 7.1083295 162.212498 6.43333625 162.6375 5.85 163.062502 5.26666375 163.649996 4.81250162 164.4    4.4875 165.150004 4.16249837 166.008328 4 166.975 4 168.041672 4 169.004162 4.20416462 169.8625 4.6125 170.720838 5.02083537 171.383331 5.591663 171.85    6.325 171.95 6.44166725 171.941667 6.533333 171.825 6.6L170.975 7.1C170.925 7.1333335 170.870834 7.14583337 170.8125 7.1375 170.754166 7.12916662    170.708333 7.10000025 170.675 7.05zM1.456 33.78C1.456 33.7146663 1.46766655 33.6703335 1.491 33.647 1.51433345 33.6236666 1.55399972 33.612 1.61   33.612L7.7 33.612C7.78400042 33.612 7.826 33.6539996 7.826 33.738L7.812 34.312C7.812 34.3680003 7.80266676 34.4053332 7.784 34.424 7.76533324    34.4426668 7.72800028 34.452 7.672 34.452L2.674 34.452C2.60866634 34.452 2.56433345 34.4613332 2.541 34.48 2.51766655 34.4986668 2.506 34.5406663 2.506   34.606L2.506 38.204C2.506 38.2600003 2.51766655 38.2973332 2.541 38.316 2.56433345 38.3346668 2.60399972 38.344 2.66 38.344L6.454 38.344C6.5006669     38.344 6.53333324 38.3533332 6.552 38.372 6.57066676 38.3906668 6.58 38.4233331 6.58 38.47L6.58 39.058C6.58 39.1046669 6.57066676 39.1349999 6.552    39.149 6.53333324 39.1630001 6.5006669 39.17 6.454 39.17L2.646 39.17C2.5993331 39.17 2.56433345 39.1793332 2.541 39.198 2.51766655 39.2166668 2.506   39.2539997 2.506 39.31L2.506 43.02C2.506 43.0760003 2.51533324 43.1133332 2.534 43.132 2.55266676 43.1506668 2.58999972 43.16 2.646 43.16L7.868    43.16C7.92400028 43.16 7.96366655 43.1669999 7.987 43.181 8.01033345 43.1950001 8.022 43.2299997 8.022 43.286L8.022 43.874C8.022 43.9580004 7.9753338   44 7.882 44L1.624 44C1.55866634 44 1.51433345 43.9883334 1.491 43.965 1.46766655 43.9416666 1.456 43.8973337 1.456 43.832L1.456 33.78zM15.666    43.762C15.7220003 43.8460004 15.75 43.9019999 15.75 43.93 15.75 43.9766669 15.7080004 44 15.624 44L14.84 44C14.7466662 44 14.6673337 43.9673337 14.602    43.902L12.502 41.004C12.4646665 40.9386663 12.4273335 40.906 12.39 40.906 12.3619999 40.906 12.3200003 40.9386663 12.264 41.004L10.066   43.902C10.0193331 43.9673337 9.94000056 44 9.828 44L9.296 44C9.17466606 44 9.114 43.962667 9.114 43.888 9.114 43.8413331 9.14199972 43.7853337 9.198     43.72L11.816 40.402C11.8533335 40.3553331 11.872 40.3086669 11.872 40.262 11.872 40.2153331 11.8533335 40.1686669 11.816 40.122L9.338 36.762C9.31933324     36.7433332 9.31 36.7153335 9.31 36.678 9.31 36.6126663 9.35199958 36.58 9.436 36.58L10.164 36.58C10.2200003 36.58 10.2643332 36.5869999 10.297 36.601     10.3296668 36.6150001 10.3599999 36.6406665 10.388 36.678L12.432 39.422C12.4600001 39.4780003 12.4926665 39.506 12.53 39.506 12.5673335 39.506    12.6046665 39.4780003 12.642 39.422L14.63 36.678C14.6580001 36.6406665 14.6883332 36.6150001 14.721 36.601 14.7536668 36.5869999 14.7979997 36.58   14.854 36.58L15.442 36.58C15.4980003 36.58 15.5329999 36.5963332 15.547 36.629 15.5610001 36.6616668 15.5493335 36.6966665 15.512 36.734L13.076    39.982C13.0386665 40.0286669 13.02 40.0753331 13.02 40.122 13.02 40.1780003 13.0386665 40.2293331 13.076 40.276L15.666 43.762zM18.046 36.58C18.1580006    36.58 18.214 36.6406661 18.214 36.762L18.214 37.406C18.214 37.4900004 18.2326665 37.532 18.27 37.532 18.3073335 37.532 18.3493331 37.5086669 18.396    37.462 18.4240001 37.4339999 18.5289991 37.3266676 18.711 37.14 18.8930009 36.9533324 19.1543316 36.7900007 19.495 36.65 19.8356684 36.5099993   20.2113313 36.44 20.622 36.44 21.2193363 36.44 21.7536643 36.5799986 22.225 36.86 22.6963357 37.1400014 23.067332 37.5599972 23.338 38.12 23.608668    38.6800028 23.744 39.3613293 23.744 40.164 23.744 40.9666707 23.608668 41.668997 23.338 42.271 23.067332 42.873003 22.6846691 43.3349984 22.19 43.657   21.6953309 43.9790016 21.1213366 44.14 20.468 44.14 20.0479979 44.14 19.6676684 44.0746673 19.327 43.944 18.9863316 43.8133327 18.6946679 43.6453344     18.452 43.44 18.377333 43.3839997 18.3260001 43.356 18.298 43.356 18.2606665 43.356 18.242 43.4166661 18.242 43.538L18.242 46.142C18.242 46.2540006     18.1906672 46.31 18.088 46.31L17.458 46.31C17.3646662 46.31 17.318 46.2586672 17.318 46.156L17.318 36.776C17.318 36.701333 17.3319999 36.6500001 17.36    36.622 17.3880001 36.5939999 17.439333 36.58 17.514 36.58L18.046 36.58zM18.242 42.432C18.5686683 42.7586683 18.8953317 43.0059992 19.222 43.174   19.5486683 43.3420008 19.8986648 43.426 20.272 43.426 21.0280038 43.426 21.6369977 43.1436695 22.099 42.579 22.5610023 42.0143305 22.792 41.2233384    22.792 40.206 22.792 39.197995 22.5610023 38.4373359 22.099 37.924 21.6369977 37.4106641 21.0606701 37.154 20.37 37.154 19.9686647 37.154 19.6070016    37.2426658 19.285 37.42 18.9629984 37.5973342 18.7086676 37.8236653 18.522 38.099 18.3353324 38.3743347 18.242 38.6426654 18.242 38.904L18.242   42.432zM26.558 43.79C26.558 43.8740004 26.5440001 43.9299999 26.516 43.958 26.4879999 43.9860001 26.4320004 44 26.348 44L25.816 44C25.7506663 44     25.7040001 43.9883334 25.676 43.965 25.6479999 43.9416666 25.634 43.8973337 25.634 43.832L25.648 33.78C25.648 33.7146663 25.6573332 33.6703335 25.676     33.647 25.6946668 33.6236666 25.7319997 33.612 25.788 33.612L26.418 33.612C26.5113338 33.612 26.558 33.6679994 26.558 33.78L26.558 43.79zM31.906    44.14C31.2153299 44.14 30.606336 43.9790016 30.079 43.657 29.551664 43.3349984 29.1433348 42.8870029 28.854 42.313 28.5646652 41.7389971 28.42    41.0786704 28.42 40.332 28.42 39.5759962 28.5669985 38.9016696 28.861 38.309 29.1550015 37.7163304 29.5679973 37.2566683 30.1 36.93 30.6320027   36.6033317 31.2386633 36.44 31.92 36.44 32.6013367 36.44 33.205664 36.6033317 33.733 36.93 34.260336 37.2566683 34.6686652 37.7139971 34.958 38.302    35.2473348 38.8900029 35.392 39.5573296 35.392 40.304 35.392 41.0506704 35.2473348 41.7156637 34.958 42.299 34.6686652 42.8823363 34.260336 43.3349984    33.733 43.657 33.205664 43.9790016 32.5966701 44.14 31.906 44.14zM31.934 43.398C32.7180039 43.398 33.3316645 43.1203361 33.775 42.565 34.2183356   42.0096639 34.44 41.2560048 34.44 40.304 34.44 39.3519952 34.2136689 38.5913362 33.761 38.022 33.3083311 37.4526638 32.6946705 37.168 31.92 37.168     31.1359961 37.168 30.5153356 37.4526638 30.058 38.022 29.6006644 38.5913362 29.372 39.3519952 29.372 40.304 29.372 41.2560048 29.6006644 42.0096639     30.058 42.565 30.5153356 43.1203361 31.1406627 43.398 31.934 43.398zM37.422 44C37.3099994 44 37.254 43.9440006 37.254 43.832L37.254 36.734C37.254     36.6313328 37.3006662 36.58 37.394 36.58L37.996 36.58C38.0800004 36.58 38.122 36.6266662 38.122 36.72L38.122 37.644C38.122 37.6906669 38.1359999    37.7186666 38.164 37.728 38.1920001 37.7373334 38.2246665 37.7233335 38.262 37.686 38.6446686 37.2566645 39.0133316 36.9416677 39.368 36.741 39.7226684   36.5403323 40.0819982 36.44 40.446 36.44 40.6233342 36.44 40.7516663 36.4516665 40.831 36.475 40.9103337 36.4983334 40.95 36.5426663 40.95 36.608L40.95    37.252C40.95 37.3173337 40.912667 37.35 40.838 37.35 40.5859987 37.3219999 40.4040006 37.308 40.292 37.308 40.0119986 37.308 39.7040017 37.3943325    39.368 37.567 39.0319983 37.7396675 38.7496678 37.961332 38.521 38.232 38.2923322 38.502668 38.178 38.773332 38.178 39.044L38.178 43.832C38.178    43.9440006 38.1173339 44 37.996 44L37.422 44zM42.966 40.71C42.966 41.1860024 43.0826655 41.6316646 43.316 42.047 43.5493345 42.4623354 43.8643313    42.7913321 44.261 43.034 44.6576686 43.2766679 45.089331 43.398 45.556 43.398 46.564005 43.398 47.3293307 42.9920041 47.852 42.18 47.8800001 42.1333331    47.9079999 42.1076667 47.936 42.103 47.9640001 42.0983333 47.9966665 42.1053332 48.034 42.124L48.51 42.39C48.5380001 42.4086668 48.5543333 42.4319999    48.559 42.46 48.5636667 42.4880001 48.5520001 42.5206665 48.524 42.558 48.1786649 43.099336 47.7586691 43.4983321 47.264 43.755 46.7693309 44.011668   46.1813367 44.14 45.5 44.14 44.8186633 44.14 44.214336 43.9813349 43.687 43.664 43.159664 43.3466651 42.7466682 42.9010029 42.448 42.327 42.1493318    41.7529971 42 41.097337 42 40.36 42 39.5666627 42.1516651 38.8736696 42.455 38.281 42.7583348 37.6883304 43.173664 37.2333349 43.701 36.916 44.228336   36.5986651 44.82333 36.44 45.486 36.44 46.5033384 36.44 47.3083304 36.7736633 47.901 37.441 48.4936696 38.1083367 48.79 39.0299941 48.79 40.206L48.79    40.29C48.79 40.3553337 48.7783334 40.4066665 48.755 40.444 48.7316665 40.4813335 48.6780004 40.5 48.594 40.5L43.064 40.5C42.9986663 40.5 42.966   40.5699993 42.966 40.71zM47.614 39.842C47.7073338 39.842 47.7703332 39.8280001 47.803 39.8 47.8356668 39.7719999 47.852 39.720667 47.852 39.646 47.852     39.1979978 47.7563343 38.7826686 47.565 38.4 47.3736657 38.0173314 47.1006684 37.7140011 46.746 37.49 46.3913316 37.2659989 45.9760024 37.154 45.5    37.154 44.9773307 37.154 44.5246686 37.2823321 44.142 37.539 43.7593314 37.7956679 43.4676677 38.1293313 43.267 38.54 43.0663323 38.9506687 42.9706666    39.3846644 42.98 39.842L47.614 39.842zM55.272 37.294C55.197333 37.294 55.16 37.331333 55.16 37.406L55.16 42.11C55.16 42.5673356 55.227666 42.8753325   55.363 43.034 55.498334 43.1926675 55.7246651 43.272 56.042 43.272L57.064 43.272C57.1573338 43.272 57.204 43.3186662 57.204 43.412L57.204 43.79C57.204     43.864667 57.1573338 43.9159999 57.064 43.944 56.8399989 43.9813335 56.4340029 44 55.846 44 55.2673304 44 54.8543346 43.8670013 54.607 43.601     54.3596654 43.3349987 54.236 42.9033363 54.236 42.306L54.236 37.42C54.236 37.3359996 54.1940004 37.294 54.11 37.294L52.92 37.294C52.8359996 37.294    52.794 37.256667 52.794 37.182L52.794 36.692C52.794 36.617333 52.831333 36.58 52.906 36.58L54.152 36.58C54.1986669 36.58 54.2313332 36.542667 54.25   36.468L54.39 34.228C54.39 34.1159994 54.4319996 34.06 54.516 34.06L55.02 34.06C55.1226672 34.06 55.174 34.1206661 55.174 34.242L55.174 36.468C55.174     36.542667 55.2066663 36.58 55.272 36.58L57.12 36.58C57.194667 36.58 57.232 36.617333 57.232 36.692L57.232 37.182C57.232 37.256667 57.1900004 37.294     57.106 37.294L55.272 37.294zM59.024 44C58.9119994 44 58.856 43.9440006 58.856 43.832L58.856 33.766C58.856 33.6633328 58.9026662 33.612 58.996     33.612L59.598 33.612C59.6913338 33.612 59.738 33.6586662 59.738 33.752L59.738 37.532C59.738 37.6440006 59.7799996 37.6580004 59.864 37.574 60.4240028     37.1633313 60.8883315 36.8716675 61.257 36.699 61.6256685 36.5263325 62.0386644 36.44 62.496 36.44 63.2240036 36.44 63.7816647 36.6289981 64.169 37.007     64.5563353 37.3850019 64.75 37.8959968 64.75 38.54L64.75 43.818C64.75 43.9393339 64.6940006 44 64.582 44L63.994 44C63.8819994 44 63.826 43.9440006    63.826 43.832L63.826 38.778C63.826 37.7326614 63.3080052 37.21 62.272 37.21 61.8426645 37.21 61.4530017 37.2986658 61.103 37.476 60.7529982 37.6533342    60.3120027 37.9613311 59.78 38.4L59.78 43.832C59.78 43.9440006 59.7193339 44 59.598 44L59.024 44zM67.494 40.71C67.494 41.1860024 67.6106655 41.6316646   67.844 42.047 68.0773345 42.4623354 68.3923314 42.7913321 68.789 43.034 69.1856686 43.2766679 69.617331 43.398 70.084 43.398 71.092005 43.398    71.8573307 42.9920041 72.38 42.18 72.4080001 42.1333331 72.4359999 42.1076667 72.464 42.103 72.4920001 42.0983333 72.5246665 42.1053332 72.562    42.124L73.038 42.39C73.0660001 42.4086668 73.0823333 42.4319999 73.087 42.46 73.0916667 42.4880001 73.0800001 42.5206665 73.052 42.558 72.7066649    43.099336 72.2866691 43.4983321 71.792 43.755 71.2973309 44.011668 70.7093367 44.14 70.028 44.14 69.3466633 44.14 68.742336 43.9813349 68.215 43.664   67.687664 43.3466651 67.2746682 42.9010029 66.976 42.327 66.6773318 41.7529971 66.528 41.097337 66.528 40.36 66.528 39.5666627 66.6796652 38.8736696     66.983 38.281 67.2863349 37.6883304 67.701664 37.2333349 68.229 36.916 68.756336 36.5986651 69.35133 36.44 70.014 36.44 71.0313384 36.44 71.8363304     36.7736633 72.429 37.441 73.0216696 38.1083367 73.318 39.0299941 73.318 40.206L73.318 40.29C73.318 40.3553337 73.3063334 40.4066665 73.283 40.444     73.2596666 40.4813335 73.2060004 40.5 73.122 40.5L67.592 40.5C67.5266663 40.5 67.494 40.5699993 67.494 40.71zM72.142 39.842C72.2353338 39.842     72.2983332 39.8280001 72.331 39.8 72.3636668 39.7719999 72.38 39.720667 72.38 39.646 72.38 39.1979978 72.2843343 38.7826686 72.093 38.4 71.9016657    38.0173314 71.6286684 37.7140011 71.274 37.49 70.9193316 37.2659989 70.5040024 37.154 70.028 37.154 69.5053307 37.154 69.0526686 37.2823321 68.67   37.539 68.2873314 37.7956679 67.9956677 38.1293313 67.795 38.54 67.5943323 38.9506687 67.4986666 39.3846644 67.508 39.842L72.142 39.842zM79.058    43.79C79.058 43.8740004 79.0440001 43.9299999 79.016 43.958 78.9879999 43.9860001 78.9320004 44 78.848 44L78.316 44C78.2506663 44 78.2040001 43.9883334   78.176 43.965 78.1479999 43.9416666 78.134 43.8973337 78.134 43.832L78.148 33.78C78.148 33.7146663 78.1573332 33.6703335 78.176 33.647 78.1946668    33.6236666 78.2319997 33.612 78.288 33.612L78.918 33.612C79.0113338 33.612 79.058 33.6679994 79.058 33.78L79.058 43.79zM85.736 43.062C85.3626648    43.4260018 84.9683354 43.6966658 84.553 43.874 84.1376646 44.0513342 83.6826691 44.14 83.188 44.14 82.450663 44.14 81.8720021 43.9580018 81.452 43.594   81.0319979 43.2299982 80.822 42.7353365 80.822 42.11 80.822 41.3819964 81.1276636 40.8080021 81.739 40.388 82.3503364 39.9679979 83.2439941 39.7160004     84.42 39.632L85.666 39.534C85.8246675 39.5153332 85.904 39.4453339 85.904 39.324L85.904 38.918C85.904 38.376664 85.7336684 37.9473349 85.393 37.63    85.0523316 37.3126651 84.5926696 37.154 84.014 37.154 83.155329 37.154 82.4413362 37.5506627 81.872 38.344 81.8439999 38.3906669 81.8160001 38.4186666    81.788 38.428 81.7599999 38.4373334 81.7273335 38.4326668 81.69 38.414L81.116 38.176C81.0786665 38.1573332 81.06 38.1340001 81.06 38.106 81.06   38.0686665 81.0739999 38.0313335 81.102 37.994 81.3913348 37.5086642 81.7879975 37.1283347 82.292 36.853 82.7960025 36.5776653 83.3839966 36.44 84.056     36.44 84.9240043 36.44 85.5983309 36.6523312 86.079 37.077 86.5596691 37.5016688 86.8 38.0919962 86.8 38.848L86.8 43.818C86.8 43.9393339 86.7440006 44    86.632 44L86.114 44C86.0019994 44 85.946 43.9393339 85.946 43.818L85.918 43.09C85.8993332 43.0246663 85.8760001 42.992 85.848 42.992 85.8199999 42.992    85.7826669 43.0153331 85.736 43.062zM85.904 40.374C85.904 40.2153325 85.8340007 40.1453332 85.694 40.164L84.644 40.248C82.7213237 40.3880007 81.76   40.9759948 81.76 42.012 81.76 42.4413355 81.9139985 42.7819987 82.222 43.034 82.5300015 43.2860013 82.9406641 43.412 83.454 43.412 83.7620015 43.412     84.0653318 43.3560006 84.364 43.244 84.6626682 43.1319994 84.9333321 42.9826676 85.176 42.796 85.6613358 42.3946647 85.904 41.998002 85.904     41.606L85.904 40.374zM90.664 37.294C90.589333 37.294 90.552 37.331333 90.552 37.406L90.552 42.11C90.552 42.5673356 90.619666 42.8753325 90.755 43.034     90.890334 43.1926675 91.1166651 43.272 91.434 43.272L92.456 43.272C92.5493338 43.272 92.596 43.3186662 92.596 43.412L92.596 43.79C92.596 43.864667    92.5493338 43.9159999 92.456 43.944 92.2319989 43.9813335 91.8260029 44 91.238 44 90.6593304 44 90.2463346 43.8670013 89.999 43.601 89.7516654    43.3349987 89.628 42.9033363 89.628 42.306L89.628 37.42C89.628 37.3359996 89.5860004 37.294 89.502 37.294L88.312 37.294C88.2279996 37.294 88.186   37.256667 88.186 37.182L88.186 36.692C88.186 36.617333 88.223333 36.58 88.298 36.58L89.544 36.58C89.5906669 36.58 89.6233332 36.542667 89.642    36.468L89.782 34.228C89.782 34.1159994 89.8239996 34.06 89.908 34.06L90.412 34.06C90.5146672 34.06 90.566 34.1206661 90.566 34.242L90.566 36.468C90.566   36.542667 90.5986663 36.58 90.664 36.58L92.512 36.58C92.586667 36.58 92.624 36.617333 92.624 36.692L92.624 37.182C92.624 37.256667 92.5820004 37.294     92.498 37.294L90.664 37.294zM94.752 40.71C94.752 41.1860024 94.8686655 41.6316646 95.102 42.047 95.3353345 42.4623354 95.6503313 42.7913321 96.047    43.034 96.4436686 43.2766679 96.875331 43.398 97.342 43.398 98.350005 43.398 99.1153307 42.9920041 99.638 42.18 99.6660001 42.1333331 99.6939999    42.1076667 99.722 42.103 99.7500001 42.0983333 99.7826665 42.1053332 99.82 42.124L100.296 42.39C100.324 42.4086668 100.340333 42.4319999 100.345 42.46   100.349667 42.4880001 100.338 42.5206665 100.31 42.558 99.9646649 43.099336 99.5446691 43.4983321 99.05 43.755 98.5553309 44.011668 97.9673367 44.14     97.286 44.14 96.6046633 44.14 96.000336 43.9813349 95.473 43.664 94.945664 43.3466651 94.5326682 42.9010029 94.234 42.327 93.9353318 41.7529971 93.786    41.097337 93.786 40.36 93.786 39.5666627 93.9376652 38.8736696 94.241 38.281 94.5443348 37.6883304 94.959664 37.2333349 95.487 36.916 96.014336   36.5986651 96.60933 36.44 97.272 36.44 98.2893384 36.44 99.0943304 36.7736633 99.687 37.441 100.27967 38.1083367 100.576 39.0299941 100.576    40.206L100.576 40.29C100.576 40.3553337 100.564333 40.4066665 100.541 40.444 100.517667 40.4813335 100.464 40.5 100.38 40.5L94.85 40.5C94.7846663 40.5    94.752 40.5699993 94.752 40.71zM99.4 39.842C99.4933338 39.842 99.5563332 39.8280001 99.589 39.8 99.6216668 39.7719999 99.638 39.720667 99.638 39.646   99.638 39.1979978 99.5423343 38.7826686 99.351 38.4 99.1596657 38.0173314 98.8866684 37.7140011 98.532 37.49 98.1773316 37.2659989 97.7620024 37.154     97.286 37.154 96.7633307 37.154 96.3106686 37.2823321 95.928 37.539 95.5453314 37.7956679 95.2536677 38.1293313 95.053 38.54 94.8523323 38.9506687    94.7566666 39.3846644 94.766 39.842L99.4 39.842zM106.778 38.148C106.572666 37.8399985 106.290335 37.5973342 105.931 37.42 105.571665 37.2426658   105.158669 37.154 104.692 37.154 104.141331 37.154 103.688668 37.2706655 103.334 37.504 102.979332 37.7373345 102.802 38.049998 102.802 38.442 102.802     38.6753345 102.892999 38.8876657 103.075 39.079 103.257001 39.2703343 103.576664 39.4359993 104.034 39.576L105.854 40.136C106.442003 40.3040008     106.880665 40.5489984 107.17 40.871 107.459335 41.1930016 107.604 41.5733311 107.604 42.012 107.604 42.4226687 107.475668 42.7889984 107.219 43.111     106.962332 43.4330016 106.610002 43.6849991 106.162 43.867 105.713998 44.0490009 105.210003 44.14 104.65 44.14 103.949997 44.14 103.324669 43.9976681     102.774 43.713 102.223331 43.4283319 101.831335 43.052669 101.598 42.586 101.579333 42.5486665 101.57 42.5206668 101.57 42.502 101.57 42.4646665    101.588666 42.4320001 101.626 42.404L102.074 42.138C102.111334 42.1193332 102.139333 42.11 102.158 42.11 102.186 42.11 102.218666 42.1286665 102.256    42.166 102.769336 42.9966708 103.557995 43.412 104.622 43.412 105.219336 43.412 105.716331 43.2930012 106.113 43.055 106.509669 42.8169988 106.708   42.502002 106.708 42.11 106.708 41.8299986 106.591335 41.5896677 106.358 41.389 106.124666 41.1883323 105.742003 41.0133341 105.21 40.864L103.782    40.444C103.109997 40.2573324 102.631668 40.0123349 102.347 39.709 102.062332 39.4056651 101.92 39.0393355 101.92 38.61 101.92 38.1806645 102.038999   37.8026683 102.277 37.476 102.515001 37.1493317 102.843998 36.8950009 103.264 36.713 103.684002 36.5309991 104.164664 36.44 104.706 36.44 105.303336     36.44 105.842331 36.5543322 106.323 36.783 106.803669 37.0116678 107.174665 37.3313313 107.436 37.742 107.492 37.8073337 107.487334 37.8586665 107.422    37.896L106.946 38.176C106.918 38.1946668 106.887667 38.2016667 106.855 38.197 106.822333 38.1923333 106.796667 38.1760001 106.778 38.148zM111.132   37.294C111.057333 37.294 111.02 37.331333 111.02 37.406L111.02 42.11C111.02 42.5673356 111.087666 42.8753325 111.223 43.034 111.358334 43.1926675    111.584665 43.272 111.902 43.272L112.924 43.272C113.017334 43.272 113.064 43.3186662 113.064 43.412L113.064 43.79C113.064 43.864667 113.017334    43.9159999 112.924 43.944 112.699999 43.9813335 112.294003 44 111.706 44 111.12733 44 110.714335 43.8670013 110.467 43.601 110.219665 43.3349987   110.096 42.9033363 110.096 42.306L110.096 37.42C110.096 37.3359996 110.054 37.294 109.97 37.294L108.78 37.294C108.696 37.294 108.654 37.256667 108.654     37.182L108.654 36.692C108.654 36.617333 108.691333 36.58 108.766 36.58L110.012 36.58C110.058667 36.58 110.091333 36.542667 110.11 36.468L110.25     34.228C110.25 34.1159994 110.292 34.06 110.376 34.06L110.88 34.06C110.982667 34.06 111.034 34.1206661 111.034 34.242L111.034 36.468C111.034 36.542667     111.066666 36.58 111.132 36.58L112.98 36.58C113.054667 36.58 113.092 36.617333 113.092 36.692L113.092 37.182C113.092 37.256667 113.05 37.294 112.966    37.294L111.132 37.294zM117.922 44C117.809999 44 117.754 43.9440006 117.754 43.832L117.754 36.734C117.754 36.6313328 117.800666 36.58 117.894    36.58L118.496 36.58C118.589334 36.58 118.636 36.6266662 118.636 36.72L118.636 37.546C118.636 37.6580006 118.678 37.6720004 118.762 37.588 119.322003   37.1773313 119.786331 36.8833342 120.155 36.706 120.523669 36.5286658 120.936664 36.44 121.394 36.44 122.11267 36.44 122.667998 36.6289981 123.06    37.007 123.452002 37.3850019 123.648 37.8913302 123.648 38.526L123.648 43.818C123.648 43.9393339 123.592001 44 123.48 44L122.892 44C122.779999 44   122.724 43.9440006 122.724 43.832L122.724 38.778C122.724 37.7326614 122.206005 37.21 121.17 37.21 120.740665 37.21 120.351002 37.2986658 120.001 37.476    119.650998 37.6533342 119.210003 37.9613311 118.678 38.4L118.678 43.832C118.678 43.9440006 118.617334 44 118.496 44L117.922 44zM126.392 40.71C126.392   41.1860024 126.508665 41.6316646 126.742 42.047 126.975334 42.4623354 127.290331 42.7913321 127.687 43.034 128.083669 43.2766679 128.515331 43.398     128.982 43.398 129.990005 43.398 130.755331 42.9920041 131.278 42.18 131.306 42.1333331 131.334 42.1076667 131.362 42.103 131.39 42.0983333 131.422666    42.1053332 131.46 42.124L131.936 42.39C131.964 42.4086668 131.980333 42.4319999 131.985 42.46 131.989667 42.4880001 131.978 42.5206665 131.95 42.558    131.604665 43.099336 131.184669 43.4983321 130.69 43.755 130.195331 44.011668 129.607337 44.14 128.926 44.14 128.244663 44.14 127.640336 43.9813349    127.113 43.664 126.585664 43.3466651 126.172668 42.9010029 125.874 42.327 125.575332 41.7529971 125.426 41.097337 125.426 40.36 125.426 39.5666627   125.577665 38.8736696 125.881 38.281 126.184335 37.6883304 126.599664 37.2333349 127.127 36.916 127.654336 36.5986651 128.24933 36.44 128.912 36.44    129.929338 36.44 130.73433 36.7736633 131.327 37.441 131.91967 38.1083367 132.216 39.0299941 132.216 40.206L132.216 40.29C132.216 40.3553337 132.204333   40.4066665 132.181 40.444 132.157667 40.4813335 132.104 40.5 132.02 40.5L126.49 40.5C126.424666 40.5 126.392 40.5699993 126.392 40.71zM131.04    39.842C131.133334 39.842 131.196333 39.8280001 131.229 39.8 131.261667 39.7719999 131.278 39.720667 131.278 39.646 131.278 39.1979978 131.182334    38.7826686 130.991 38.4 130.799666 38.0173314 130.526668 37.7140011 130.172 37.49 129.817332 37.2659989 129.402002 37.154 128.926 37.154 128.403331    37.154 127.950669 37.2823321 127.568 37.539 127.185331 37.7956679 126.893668 38.1293313 126.693 38.54 126.492332 38.9506687 126.396667 39.3846644    126.406 39.842L131.04 39.842zM143.304 36.58C143.350667 36.58 143.388 36.5963332 143.416 36.629 143.444 36.6616668 143.448667 36.7013331 143.43   36.748L141.316 43.832C141.288 43.9440006 141.208667 44 141.078 44L140.518 44C140.368666 44 140.275334 43.9440006 140.238 43.832L138.46 38.246C138.432    38.1619996 138.404 38.12 138.376 38.12 138.357333 38.12 138.334 38.1619996 138.306 38.246L136.612 43.832C136.584 43.9440006 136.504667 44 136.374   44L135.786 44C135.627333 44 135.534 43.9440006 135.506 43.832L133.308 36.762 133.294 36.706C133.294 36.6686665 133.308 36.6383334 133.336 36.615     133.364 36.5916665 133.401333 36.58 133.448 36.58L134.064 36.58C134.166667 36.58 134.232 36.6266662 134.26 36.72L136.052 42.544C136.08 42.6373338     136.112666 42.684 136.15 42.684 136.187334 42.684 136.22 42.6326672 136.248 42.53L138.012 36.692C138.04 36.617333 138.100666 36.58 138.194    36.58L138.712 36.58C138.814667 36.58 138.88 36.6266662 138.908 36.72L140.756 42.544C140.784 42.6373338 140.816666 42.684 140.854 42.684 140.891334    42.684 140.924 42.6326672 140.952 42.53L142.66 36.706C142.706667 36.6219996 142.776666 36.58 142.87 36.58L143.304 36.58zM149.492 38.148C149.286666   37.8399985 149.004335 37.5973342 148.645 37.42 148.285665 37.2426658 147.872669 37.154 147.406 37.154 146.855331 37.154 146.402668 37.2706655 146.048    37.504 145.693332 37.7373345 145.516 38.049998 145.516 38.442 145.516 38.6753345 145.606999 38.8876657 145.789 39.079 145.971001 39.2703343 146.290664    39.4359993 146.748 39.576L148.568 40.136C149.156003 40.3040008 149.594665 40.5489984 149.884 40.871 150.173335 41.1930016 150.318 41.5733311 150.318   42.012 150.318 42.4226687 150.189668 42.7889984 149.933 43.111 149.676332 43.4330016 149.324002 43.6849991 148.876 43.867 148.427998 44.0490009    147.924003 44.14 147.364 44.14 146.663996 44.14 146.038669 43.9976681 145.488 43.713 144.937331 43.4283319 144.545335 43.052669 144.312 42.586    144.293333 42.5486665 144.284 42.5206668 144.284 42.502 144.284 42.4646665 144.302666 42.4320001 144.34 42.404L144.788 42.138C144.825334 42.1193332    144.853333 42.11 144.872 42.11 144.9 42.11 144.932666 42.1286665 144.97 42.166 145.483336 42.9966708 146.271995 43.412 147.336 43.412 147.933336 43.412    148.430331 43.2930012 148.827 43.055 149.223669 42.8169988 149.422 42.502002 149.422 42.11 149.422 41.8299986 149.305335 41.5896677 149.072 41.389   148.838665 41.1883323 148.456003 41.0133341 147.924 40.864L146.496 40.444C145.823997 40.2573324 145.345668 40.0123349 145.061 39.709 144.776332    39.4056651 144.634 39.0393355 144.634 38.61 144.634 38.1806645 144.752999 37.8026683 144.991 37.476 145.229001 37.1493317 145.557998 36.8950009 145.978   36.713 146.398002 36.5309991 146.878664 36.44 147.42 36.44 148.017336 36.44 148.556331 36.5543322 149.037 36.783 149.517669 37.0116678 149.888665    37.3313313 150.15 37.742 150.206 37.8073337 150.201334 37.8586665 150.136 37.896L149.66 38.176C149.632 38.1946668 149.601667 38.2016667 149.569 38.197    149.536333 38.1923333 149.510667 38.1760001 149.492 38.148zM10.472 53.58C10.5186669 53.58 10.5559999 53.5963332 10.584 53.629 10.6120001 53.6616668    10.6166668 53.7013331 10.598 53.748L8.484 60.832C8.45599986 60.9440006 8.37666732 61 8.246 61L7.686 61C7.53666592 61 7.44333352 60.9440006 7.406   60.832L5.628 55.246C5.59999986 55.1619996 5.57200014 55.12 5.544 55.12 5.52533324 55.12 5.50200014 55.1619996 5.474 55.246L3.78 60.832C3.75199986    60.9440006 3.67266732 61 3.542 61L2.954 61C2.79533254 61 2.70200014 60.9440006 2.674 60.832L.476 53.762.462 53.706C.462 53.6686665.47599986   53.6383334.504 53.615.53200014 53.5916665.5693331 53.58.616 53.58L1.232 53.58C1.33466718 53.58 1.39999986 53.6266662 1.428 53.72L3.22 59.544C3.24800014    59.6373338 3.28066648 59.684 3.318 59.684 3.35533352 59.684 3.38799986 59.6326672 3.416 59.53L5.18 53.692C5.20800014 53.617333 5.2686662 53.58 5.362    53.58L5.88 53.58C5.98266718 53.58 6.04799986 53.6266662 6.076 53.72L7.924 59.544C7.95200014 59.6373338 7.98466648 59.684 8.022 59.684 8.05933352 59.684    8.09199986 59.6326672 8.12 59.53L9.828 53.706C9.8746669 53.6219996 9.9446662 53.58 10.038 53.58L10.472 53.58zM13.216 51.886C13.216 51.9700004    13.2020001 52.0329998 13.174 52.075 13.1459999 52.1170002 13.0900004 52.138 13.006 52.138L12.362 52.138C12.287333 52.138 12.2383334 52.1193335 12.215    52.082 12.1916666 52.0446665 12.18 51.988667 12.18 51.914L12.18 50.822C12.18 50.6819993 12.2406661 50.612 12.362 50.612L13.034 50.612C13.1553339 50.612    13.216 50.6773327 13.216 50.808L13.216 51.886zM13.16 60.79C13.16 60.8740004 13.1460001 60.9299999 13.118 60.958 13.0899999 60.9860001 13.0293338 61    12.936 61L12.418 61C12.3526663 61 12.3060001 60.9883334 12.278 60.965 12.2499999 60.9416666 12.236 60.8973337 12.236 60.832L12.236 53.748C12.236   53.6826663 12.2476666 53.6383334 12.271 53.615 12.2943334 53.5916665 12.3339997 53.58 12.39 53.58L13.006 53.58C13.0620003 53.58 13.1016666 53.5916665    13.125 53.615 13.1483335 53.6383334 13.16 53.6826663 13.16 53.748L13.16 60.79zM17.15 54.294C17.075333 54.294 17.038 54.331333 17.038 54.406L17.038    59.11C17.038 59.5673356 17.105666 59.8753325 17.241 60.034 17.376334 60.1926675 17.6026651 60.272 17.92 60.272L18.942 60.272C19.0353338 60.272 19.082    60.3186662 19.082 60.412L19.082 60.79C19.082 60.864667 19.0353338 60.9159999 18.942 60.944 18.7179989 60.9813335 18.3120029 61 17.724 61 17.1453304 61   16.7323346 60.8670013 16.485 60.601 16.2376654 60.3349987 16.114 59.9033363 16.114 59.306L16.114 54.42C16.114 54.3359996 16.0720004 54.294 15.988    54.294L14.798 54.294C14.7139996 54.294 14.672 54.256667 14.672 54.182L14.672 53.692C14.672 53.617333 14.709333 53.58 14.784 53.58L16.03   53.58C16.0766669 53.58 16.1093332 53.542667 16.128 53.468L16.268 51.228C16.268 51.1159994 16.3099996 51.06 16.394 51.06L16.898 51.06C17.0006672 51.06    17.052 51.1206661 17.052 51.242L17.052 53.468C17.052 53.542667 17.0846663 53.58 17.15 53.58L18.998 53.58C19.072667 53.58 19.11 53.617333 19.11    53.692L19.11 54.182C19.11 54.256667 19.0680004 54.294 18.984 54.294L17.15 54.294zM20.902 61C20.7899994 61 20.734 60.9440006 20.734 60.832L20.734   50.766C20.734 50.6633328 20.7806662 50.612 20.874 50.612L21.476 50.612C21.5693338 50.612 21.616 50.6586662 21.616 50.752L21.616 54.532C21.616    54.6440006 21.6579996 54.6580004 21.742 54.574 22.3020028 54.1633313 22.7663315 53.8716675 23.135 53.699 23.5036685 53.5263325 23.9166644 53.44 24.374    53.44 25.1020036 53.44 25.6596647 53.6289981 26.047 54.007 26.4343353 54.3850019 26.628 54.8959968 26.628 55.54L26.628 60.818C26.628 60.9393339    26.5720006 61 26.46 61L25.872 61C25.7599994 61 25.704 60.9440006 25.704 60.832L25.704 55.778C25.704 54.7326614 25.1860052 54.21 24.15 54.21 23.7206645   54.21 23.3310017 54.2986658 22.981 54.476 22.6309982 54.6533342 22.1900027 54.9613311 21.658 55.4L21.658 60.832C21.658 60.9440006 21.5973339 61 21.476     61L20.902 61zM29.848 51.886C29.848 51.9700004 29.8340001 52.0329998 29.806 52.075 29.7779999 52.1170002 29.7220004 52.138 29.638 52.138L28.994    52.138C28.919333 52.138 28.8703335 52.1193335 28.847 52.082 28.8236666 52.0446665 28.812 51.988667 28.812 51.914L28.812 50.822C28.812 50.6819993    28.8726661 50.612 28.994 50.612L29.666 50.612C29.7873339 50.612 29.848 50.6773327 29.848 50.808L29.848 51.886zM29.792 60.79C29.792 60.8740004    29.7780001 60.9299999 29.75 60.958 29.7219999 60.9860001 29.6613338 61 29.568 61L29.05 61C28.9846663 61 28.9380001 60.9883334 28.91 60.965 28.8819999    60.9416666 28.868 60.8973337 28.868 60.832L28.868 53.748C28.868 53.6826663 28.8796665 53.6383334 28.903 53.615 28.9263335 53.5916665 28.9659997 53.58    29.022 53.58L29.638 53.58C29.6940003 53.58 29.7336666 53.5916665 29.757 53.615 29.7803334 53.6383334 29.792 53.6826663 29.792 53.748L29.792    60.79zM32.284 61C32.1719994 61 32.116 60.9440006 32.116 60.832L32.116 53.734C32.116 53.6313328 32.1626662 53.58 32.256 53.58L32.858 53.58C32.9513338   53.58 32.998 53.6266662 32.998 53.72L32.998 54.546C32.998 54.6580006 33.0399996 54.6720004 33.124 54.588 33.6840028 54.1773313 34.1483315 53.8833342     34.517 53.706 34.8856685 53.5286658 35.2986644 53.44 35.756 53.44 36.4746703 53.44 37.029998 53.6289981 37.422 54.007 37.814002 54.3850019 38.01    54.8913302 38.01 55.526L38.01 60.818C38.01 60.9393339 37.9540006 61 37.842 61L37.254 61C37.1419994 61 37.086 60.9440006 37.086 60.832L37.086    55.778C37.086 54.7326614 36.5680052 54.21 35.532 54.21 35.1026645 54.21 34.7130018 54.2986658 34.363 54.476 34.0129983 54.6533342 33.5720027 54.9613311    33.04 55.4L33.04 60.832C33.04 60.9440006 32.9793339 61 32.858 61L32.284 61zM46.312 61.14C45.6213299 61.14 45.012336 60.9790016 44.485 60.657 43.957664   60.3349984 43.5493348 59.8870029 43.26 59.313 42.9706652 58.7389971 42.826 58.0786704 42.826 57.332 42.826 56.5759962 42.9729985 55.9016696 43.267     55.309 43.5610015 54.7163304 43.9739973 54.2566683 44.506 53.93 45.0380027 53.6033317 45.6446633 53.44 46.326 53.44 47.0073367 53.44 47.611664    53.6033317 48.139 53.93 48.666336 54.2566683 49.0746652 54.7139971 49.364 55.302 49.6533348 55.8900029 49.798 56.5573296 49.798 57.304 49.798   58.0506704 49.6533348 58.7156637 49.364 59.299 49.0746652 59.8823363 48.666336 60.3349984 48.139 60.657 47.611664 60.9790016 47.0026701 61.14 46.312     61.14zM46.34 60.398C47.1240039 60.398 47.7376645 60.1203361 48.181 59.565 48.6243355 59.0096639 48.846 58.2560048 48.846 57.304 48.846 56.3519952     48.6196689 55.5913362 48.167 55.022 47.7143311 54.4526638 47.1006705 54.168 46.326 54.168 45.5419961 54.168 44.9213356 54.4526638 44.464 55.022     44.0066644 55.5913362 43.778 56.3519952 43.778 57.304 43.778 58.2560048 44.0066644 59.0096639 44.464 59.565 44.9213356 60.1203361 45.5466627 60.398     46.34 60.398zM54.026 60.37C54.4460021 60.37 54.8543314 60.2580011 55.251 60.034 55.6476686 59.8099989 56.0559979 59.4833355 56.476 59.054L56.476    53.748C56.476 53.6359994 56.5366661 53.58 56.658 53.58L57.246 53.58C57.3486672 53.58 57.4 53.6359994 57.4 53.748L57.4 60.846C57.4 60.9486672 57.3533338   61 57.26 61L56.658 61C56.5646662 61 56.518 60.9533338 56.518 60.86L56.518 60.006C56.518 59.9593331 56.5086668 59.9313334 56.49 59.922 56.4713332     59.9126666 56.4386669 59.9266665 56.392 59.964 55.8786641 60.4026689 55.4213353 60.7083325 55.02 60.881 54.6186647 61.0536675 54.2173353 61.14 53.816     61.14 53.1626634 61.14 52.6213355 60.9463353 52.192 60.559 51.7626645 60.1716647 51.548 59.6653365 51.548 59.04L51.548 53.762C51.548 53.6406661     51.6086661 53.58 51.73 53.58L52.318 53.58C52.4206672 53.58 52.472 53.6359994 52.472 53.748L52.472 58.732C52.472 59.2266691 52.6119986 59.6233318 52.892     59.922 53.1720014 60.2206682 53.5499976 60.37 54.026 60.37zM59.892 61C59.7799994 61 59.724 60.9440006 59.724 60.832L59.724 53.734C59.724 53.6313328     59.7706662 53.58 59.864 53.58L60.466 53.58C60.5500004 53.58 60.592 53.6266662 60.592 53.72L60.592 54.644C60.592 54.6906669 60.6059999 54.7186666 60.634     54.728 60.6620001 54.7373334 60.6946665 54.7233335 60.732 54.686 61.1146686 54.2566645 61.4833316 53.9416677 61.838 53.741 62.1926684 53.5403323    62.5519982 53.44 62.916 53.44 63.0933342 53.44 63.2216663 53.4516665 63.301 53.475 63.3803337 53.4983335 63.42 53.5426663 63.42 53.608L63.42    54.252C63.42 54.3173337 63.382667 54.35 63.308 54.35 63.0559987 54.3219999 62.8740006 54.308 62.762 54.308 62.4819986 54.308 62.1740017 54.3943325   61.838 54.567 61.5019983 54.7396675 61.2196678 54.961332 60.991 55.232 60.7623322 55.502668 60.648 55.773332 60.648 56.044L60.648 60.832C60.648    60.9440006 60.5873339 61 60.466 61L59.892 61zM71.568 53.58C71.642667 53.58 71.68 53.6219996 71.68 53.706L71.68 54.182C71.68 54.256667 71.6380004 54.294   71.554 54.294L69.86 54.294C69.785333 54.294 69.748 54.331333 69.748 54.406L69.748 60.818C69.748 60.9393339 69.7013338 61 69.608 61L68.964 61C68.8706662    61 68.824 60.9440006 68.824 60.832L68.824 54.406C68.824 54.331333 68.7960003 54.294 68.74 54.294L67.27 54.294C67.195333 54.294 67.158 54.256667 67.158    54.182L67.158 53.706C67.158 53.6219996 67.1999996 53.58 67.284 53.58L68.712 53.58C68.7586669 53.58 68.7889999 53.5706668 68.803 53.552 68.8170001    53.5333332 68.824 53.5006669 68.824 53.454L68.824 52.39C68.824 51.2046607 69.388661 50.612 70.518 50.612L71.61 50.612C71.7033338 50.612 71.75    50.6586662 71.75 50.752L71.75 51.186C71.75 51.2700004 71.7033338 51.312 71.61 51.312L70.574 51.312C70.2753318 51.312 70.0606673 51.4006658 69.93 51.578    69.7993327 51.7553342 69.734 52.0213316 69.734 52.376L69.734 53.468C69.734 53.542667 69.771333 53.58 69.846 53.58L71.568 53.58zM76.216 61.14C75.5253299    61.14 74.916336 60.9790016 74.389 60.657 73.861664 60.3349984 73.4533348 59.8870029 73.164 59.313 72.8746652 58.7389971 72.73 58.0786704 72.73 57.332    72.73 56.5759962 72.8769985 55.9016696 73.171 55.309 73.4650015 54.7163304 73.8779973 54.2566683 74.41 53.93 74.9420027 53.6033317 75.5486633 53.44    76.23 53.44 76.9113367 53.44 77.515664 53.6033317 78.043 53.93 78.570336 54.2566683 78.9786652 54.7139971 79.268 55.302 79.5573348 55.8900029 79.702   56.5573296 79.702 57.304 79.702 58.0506704 79.5573348 58.7156637 79.268 59.299 78.9786652 59.8823363 78.570336 60.3349984 78.043 60.657 77.515664    60.9790016 76.9066701 61.14 76.216 61.14zM76.244 60.398C77.0280039 60.398 77.6416645 60.1203361 78.085 59.565 78.5283356 59.0096639 78.75 58.2560048    78.75 57.304 78.75 56.3519952 78.5236689 55.5913362 78.071 55.022 77.6183311 54.4526638 77.0046705 54.168 76.23 54.168 75.4459961 54.168 74.8253356    54.4526638 74.368 55.022 73.9106644 55.5913362 73.682 56.3519952 73.682 57.304 73.682 58.2560048 73.9106644 59.0096639 74.368 59.565 74.8253356    60.1203361 75.4506627 60.398 76.244 60.398zM84.546 53.44C85.7780062 53.44 86.72533 53.9859945 87.388 55.078 87.4160001 55.1340003 87.4276667 55.1736666    87.423 55.197 87.4183333 55.2203334 87.3926669 55.2413332 87.346 55.26L86.758 55.456C86.7486666 55.4653334 86.7300001 55.47 86.702 55.47 86.6646665    55.47 86.6273335 55.4420003 86.59 55.386 86.2539983 54.9566645 85.9343348 54.6463343 85.631 54.455 85.3276652 54.2636657 84.9893352 54.168 84.616    54.168 83.8413295 54.168 83.220669 54.4503305 82.754 55.015 82.287331 55.5796695 82.054 56.3379952 82.054 57.29 82.054 58.2420048 82.287331 59.0003305   82.754 59.565 83.220669 60.1296695 83.8459961 60.412 84.63 60.412 85.0873356 60.412 85.4909983 60.3000011 85.841 60.076 86.1910017 59.8519989    86.5106652 59.5113356 86.8 59.054 86.8560003 58.979333 86.9119997 58.9606665 86.968 58.998L87.458 59.222C87.5140003 59.2500001 87.5280001 59.3059996    87.5 59.39 87.1919985 59.931336 86.7883358 60.3583318 86.289 60.671 85.7896642 60.9836682 85.20867 61.14 84.546 61.14 83.8739966 61.14 83.2766693    60.9790016 82.754 60.657 82.2313307 60.3349984 81.8253348 59.8846696 81.536 59.306 81.2466652 58.7273304 81.102 58.0646704 81.102 57.318 81.102    56.5713296 81.2489985 55.9040029 81.543 55.316 81.8370015 54.7279971 82.2453307 54.268335 82.768 53.937 83.2906693 53.605665 83.88333 53.44 84.546   53.44zM91.49 60.37C91.9100021 60.37 92.3183313 60.2580011 92.715 60.034 93.1116687 59.8099989 93.5199979 59.4833355 93.94 59.054L93.94 53.748C93.94    53.6359994 94.0006661 53.58 94.122 53.58L94.71 53.58C94.8126672 53.58 94.864 53.6359994 94.864 53.748L94.864 60.846C94.864 60.9486672 94.8173338 61   94.724 61L94.122 61C94.0286662 61 93.982 60.9533338 93.982 60.86L93.982 60.006C93.982 59.9593331 93.9726668 59.9313334 93.954 59.922 93.9353332    59.9126666 93.9026669 59.9266665 93.856 59.964 93.3426641 60.4026689 92.8853353 60.7083325 92.484 60.881 92.0826647 61.0536675 91.6813353 61.14 91.28   61.14 90.6266634 61.14 90.0853355 60.9463353 89.656 60.559 89.2266645 60.1716647 89.012 59.6653365 89.012 59.04L89.012 53.762C89.012 53.6406661    89.0726661 53.58 89.194 53.58L89.782 53.58C89.8846672 53.58 89.936 53.6359994 89.936 53.748L89.936 58.732C89.936 59.2266691 90.0759986 59.6233318   90.356 59.922 90.6360014 60.2206682 91.0139976 60.37 91.49 60.37zM101.612 55.148C101.406666 54.8399985 101.124335 54.5973342 100.765 54.42 100.405665    54.2426658 99.992669 54.154 99.526 54.154 98.9753306 54.154 98.5226684 54.2706655 98.168 54.504 97.8133316 54.7373345 97.636 55.049998 97.636 55.442    97.636 55.6753345 97.7269991 55.8876657 97.909 56.079 98.0910009 56.2703343 98.4106644 56.4359993 98.868 56.576L100.688 57.136C101.276003 57.3040008   101.714665 57.5489984 102.004 57.871 102.293335 58.1930016 102.438 58.5733311 102.438 59.012 102.438 59.4226687 102.309668 59.7889984 102.053 60.111     101.796332 60.4330016 101.444002 60.6849991 100.996 60.867 100.547998 61.0490009 100.044003 61.14 99.484 61.14 98.7839965 61.14 98.1586694 60.9976681     97.608 60.713 97.0573306 60.4283319 96.6653345 60.052669 96.432 59.586 96.4133332 59.5486665 96.404 59.5206668 96.404 59.502 96.404 59.4646665    96.4226665 59.4320001 96.46 59.404L96.908 59.138C96.9453335 59.1193332 96.9733332 59.11 96.992 59.11 97.0200001 59.11 97.0526665 59.1286665 97.09   59.166 97.6033359 59.9966708 98.3919947 60.412 99.456 60.412 100.053336 60.412 100.550331 60.2930012 100.947 60.055 101.343669 59.8169988 101.542    59.502002 101.542 59.11 101.542 58.8299986 101.425335 58.5896677 101.192 58.389 100.958666 58.1883323 100.576003 58.0133341 100.044 57.864L98.616   57.444C97.9439966 57.2573324 97.4656681 57.0123349 97.181 56.709 96.8963319 56.4056652 96.754 56.0393355 96.754 55.61 96.754 55.1806645 96.8729988     54.8026683 97.111 54.476 97.3490012 54.1493317 97.6779979 53.8950009 98.098 53.713 98.5180021 53.5309991 98.998664 53.44 99.54 53.44 100.137336 53.44     100.676331 53.5543322 101.157 53.783 101.637669 54.0116678 102.008665 54.3313313 102.27 54.742 102.326 54.8073337 102.321334 54.8586665 102.256     54.896L101.78 55.176C101.752 55.1946668 101.721667 55.2016667 101.689 55.197 101.656333 55.1923333 101.630667 55.1760001 101.612 55.148zM111.692    60.062C111.318665 60.4260018 110.924335 60.6966658 110.509 60.874 110.093665 61.0513342 109.638669 61.14 109.144 61.14 108.406663 61.14 107.828002    60.9580018 107.408 60.594 106.987998 60.2299982 106.778 59.7353365 106.778 59.11 106.778 58.3819964 107.083664 57.8080021 107.695 57.388 108.306336    56.9679979 109.199994 56.7160004 110.376 56.632L111.622 56.534C111.780667 56.5153332 111.86 56.4453339 111.86 56.324L111.86 55.918C111.86 55.376664    111.689668 54.9473349 111.349 54.63 111.008332 54.3126651 110.54867 54.154 109.97 54.154 109.111329 54.154 108.397336 54.5506627 107.828 55.344 107.8    55.3906669 107.772 55.4186666 107.744 55.428 107.716 55.4373334 107.683334 55.4326668 107.646 55.414L107.072 55.176C107.034666 55.1573332 107.016    55.1340001 107.016 55.106 107.016 55.0686665 107.03 55.0313335 107.058 54.994 107.347335 54.5086642 107.743997 54.1283347 108.248 53.853 108.752003    53.5776653 109.339997 53.44 110.012 53.44 110.880004 53.44 111.554331 53.6523312 112.035 54.077 112.515669 54.5016688 112.756 55.0919962 112.756   55.848L112.756 60.818C112.756 60.9393339 112.700001 61 112.588 61L112.07 61C111.957999 61 111.902 60.9393339 111.902 60.818L111.874 60.09C111.855333     60.0246663 111.832 59.992 111.804 59.992 111.776 59.992 111.738667 60.0153331 111.692 60.062zM111.86 57.374C111.86 57.2153325 111.790001 57.1453332     111.65 57.164L110.6 57.248C108.677324 57.3880007 107.716 57.9759948 107.716 59.012 107.716 59.4413355 107.869998 59.7819987 108.178 60.034 108.486002     60.2860013 108.896664 60.412 109.41 60.412 109.718002 60.412 110.021332 60.3560006 110.32 60.244 110.618668 60.1319994 110.889332 59.9826676 111.132    59.796 111.617336 59.3946647 111.86 58.998002 111.86 58.606L111.86 57.374zM115.122 61C115.009999 61 114.954 60.9440006 114.954 60.832L114.954   53.734C114.954 53.6313328 115.000666 53.58 115.094 53.58L115.696 53.58C115.78 53.58 115.822 53.6266662 115.822 53.72L115.822 54.644C115.822 54.6906669     115.836 54.7186666 115.864 54.728 115.892 54.7373334 115.924666 54.7233335 115.962 54.686 116.344669 54.2566645 116.713332 53.9416677 117.068 53.741    117.422668 53.5403323 117.781998 53.44 118.146 53.44 118.323334 53.44 118.451666 53.4516665 118.531 53.475 118.610334 53.4983335 118.65 53.5426663    118.65 53.608L118.65 54.252C118.65 54.3173337 118.612667 54.35 118.538 54.35 118.285999 54.3219999 118.104001 54.308 117.992 54.308 117.711999 54.308    117.404002 54.3943325 117.068 54.567 116.731998 54.7396675 116.449668 54.961332 116.221 55.232 115.992332 55.502668 115.878 55.773332 115.878    56.044L115.878 60.832C115.878 60.9440006 115.817334 61 115.696 61L115.122 61zM120.666 57.71C120.666 58.1860024 120.782666 58.6316646 121.016 59.047    121.249335 59.4623354 121.564331 59.7913321 121.961 60.034 122.357669 60.2766679 122.789331 60.398 123.256 60.398 124.264005 60.398 125.029331   59.9920041 125.552 59.18 125.58 59.1333331 125.608 59.1076667 125.636 59.103 125.664 59.0983333 125.696666 59.1053332 125.734 59.124L126.21    59.39C126.238 59.4086668 126.254333 59.4319999 126.259 59.46 126.263667 59.4880001 126.252 59.5206665 126.224 59.558 125.878665 60.099336 125.458669    60.4983321 124.964 60.755 124.469331 61.011668 123.881337 61.14 123.2 61.14 122.518663 61.14 121.914336 60.9813349 121.387 60.664 120.859664 60.3466651    120.446668 59.9010029 120.148 59.327 119.849332 58.7529971 119.7 58.097337 119.7 57.36 119.7 56.5666627 119.851665 55.8736696 120.155 55.281 120.458335    54.6883304 120.873664 54.2333349 121.401 53.916 121.928336 53.5986651 122.52333 53.44 123.186 53.44 124.203338 53.44 125.00833 53.7736633 125.601    54.441 126.19367 55.1083367 126.49 56.0299941 126.49 57.206L126.49 57.29C126.49 57.3553337 126.478333 57.4066665 126.455 57.444 126.431667 57.4813335    126.378 57.5 126.294 57.5L120.764 57.5C120.698666 57.5 120.666 57.5699993 120.666 57.71zM125.314 56.842C125.407334 56.842 125.470333 56.8280001 125.503    56.8 125.535667 56.7719999 125.552 56.720667 125.552 56.646 125.552 56.1979978 125.456334 55.7826686 125.265 55.4 125.073666 55.0173314 124.800668   54.7140011 124.446 54.49 124.091332 54.2659989 123.676002 54.154 123.2 54.154 122.677331 54.154 122.224669 54.2823321 121.842 54.539 121.459331    54.795668 121.167668 55.1293313 120.967 55.54 120.766332 55.9506687 120.670667 56.3846644 120.68 56.842L125.314 56.842zM132.622 60.062C132.248665   60.4260018 131.854335 60.6966658 131.439 60.874 131.023665 61.0513342 130.568669 61.14 130.074 61.14 129.336663 61.14 128.758002 60.9580018 128.338    60.594 127.917998 60.2299982 127.708 59.7353365 127.708 59.11 127.708 58.3819964 128.013664 57.8080021 128.625 57.388 129.236336 56.9679979 130.129994    56.7160004 131.306 56.632L132.552 56.534C132.710667 56.5153332 132.79 56.4453339 132.79 56.324L132.79 55.918C132.79 55.376664 132.619668 54.9473349    132.279 54.63 131.938332 54.3126651 131.47867 54.154 130.9 54.154 130.041329 54.154 129.327336 54.5506627 128.758 55.344 128.73 55.3906669 128.702   55.4186666 128.674 55.428 128.646 55.4373334 128.613334 55.4326668 128.576 55.414L128.002 55.176C127.964666 55.1573332 127.946 55.1340001 127.946    55.106 127.946 55.0686665 127.96 55.0313335 127.988 54.994 128.277335 54.5086642 128.673997 54.1283347 129.178 53.853 129.682003 53.5776653 130.269997    53.44 130.942 53.44 131.810004 53.44 132.484331 53.6523312 132.965 54.077 133.445669 54.5016688 133.686 55.0919962 133.686 55.848L133.686    60.818C133.686 60.9393339 133.630001 61 133.518 61L133 61C132.887999 61 132.832 60.9393339 132.832 60.818L132.804 60.09C132.785333 60.0246663 132.762    59.992 132.734 59.992 132.706 59.992 132.668667 60.0153331 132.622 60.062zM132.79 57.374C132.79 57.2153325 132.720001 57.1453332 132.58 57.164L131.53    57.248C129.607324 57.3880007 128.646 57.9759948 128.646 59.012 128.646 59.4413355 128.799998 59.7819987 129.108 60.034 129.416002 60.2860013 129.826664    60.412 130.34 60.412 130.648002 60.412 130.951332 60.3560006 131.25 60.244 131.548668 60.1319994 131.819332 59.9826676 132.062 59.796 132.547336   59.3946647 132.79 58.998002 132.79 58.606L132.79 57.374zM140.308 55.148C140.102666 54.8399985 139.820335 54.5973342 139.461 54.42 139.101665 54.2426658    138.688669 54.154 138.222 54.154 137.671331 54.154 137.218668 54.2706655 136.864 54.504 136.509332 54.7373345 136.332 55.049998 136.332 55.442 136.332    55.6753345 136.422999 55.8876657 136.605 56.079 136.787001 56.2703343 137.106664 56.4359993 137.564 56.576L139.384 57.136C139.972003 57.3040008    140.410665 57.5489984 140.7 57.871 140.989335 58.1930016 141.134 58.5733311 141.134 59.012 141.134 59.4226687 141.005668 59.7889984 140.749 60.111   140.492332 60.4330016 140.140002 60.6849991 139.692 60.867 139.243998 61.0490009 138.740003 61.14 138.18 61.14 137.479997 61.14 136.854669 60.9976681    136.304 60.713 135.753331 60.4283319 135.361335 60.052669 135.128 59.586 135.109333 59.5486665 135.1 59.5206668 135.1 59.502 135.1 59.4646665   135.118666 59.4320001 135.156 59.404L135.604 59.138C135.641334 59.1193332 135.669333 59.11 135.688 59.11 135.716 59.11 135.748666 59.1286665 135.786     59.166 136.299336 59.9966708 137.087995 60.412 138.152 60.412 138.749336 60.412 139.246331 60.2930012 139.643 60.055 140.039669 59.8169988 140.238    59.502002 140.238 59.11 140.238 58.8299986 140.121335 58.5896677 139.888 58.389 139.654666 58.1883323 139.272003 58.0133341 138.74 57.864L137.312   57.444C136.639997 57.2573324 136.161668 57.0123349 135.877 56.709 135.592332 56.4056652 135.45 56.0393355 135.45 55.61 135.45 55.1806645 135.568999    54.8026683 135.807 54.476 136.045001 54.1493317 136.373998 53.8950009 136.794 53.713 137.214002 53.5309991 137.694664 53.44 138.236 53.44 138.833336    53.44 139.372331 53.5543322 139.853 53.783 140.333669 54.0116678 140.704665 54.3313313 140.966 54.742 141.022 54.8073337 141.017334 54.8586665 140.952   54.896L140.476 55.176C140.448 55.1946668 140.417667 55.2016667 140.385 55.197 140.352333 55.1923333 140.326667 55.1760001 140.308 55.148z",
	          fill: "#FFF", fillRule: "evenodd" })
	      ),
	      _react2.default.createElement(
	        "style",
	        { jsx: true },
	        "\n            .logo-wrapper {\n              height: 100%;\n              width: 100%;\n              padding: 32px;\n              display: flex;\n              flex-direction: column;\n              justify-content: center;\n              align-items: center;\n            }\n          "
	      )
	    );
	  };
	
	  return Logo;
	}(_react2.default.PureComponent);
	
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowDimensions = function (_React$Component) {
	    _inherits(WindowDimensions, _React$Component);
	
	    function WindowDimensions() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WindowDimensions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            width: '0',
	            height: '0',
	            currentPath: ''
	        }, _this.updateWindowDimensions = function () {
	            if (window) {
	                _this.setState({
	                    width: window.innerWidth,
	                    height: window.innerHeight
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    WindowDimensions.prototype.componentDidMount = function componentDidMount() {
	        this.updateWindowDimensions();
	        if (window) {
	            window.addEventListener('resize', this.updateWindowDimensions);
	        }
	    };
	
	    WindowDimensions.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (window) {
	            window.removeEventListener('resize', this.updateWindowDimensions);
	        }
	    };
	
	    WindowDimensions.prototype.render = function render() {
	        var _this2 = this;
	
	        var children = void 0;
	        if (this.state.width > 0) {
	            children = _react2.default.Children.map(this.props.children, function (child) {
	                return _react2.default.cloneElement(child, _this2.state);
	            });
	        } else {
	            children = this.props.children;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            children,
	            _react2.default.createElement(
	                'style',
	                { jsx: true },
	                '\n                  div {\n                      height: 100%;\n                  }\n              '
	            )
	        );
	    };
	
	    return WindowDimensions;
	}(_react2.default.Component);
	
	exports.default = WindowDimensions;
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(459);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _favicon = __webpack_require__(354);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	__webpack_require__(341);
	
	var _MobNav = __webpack_require__(237);
	
	var _MobNav2 = _interopRequireDefault(_MobNav);
	
	var _deskNav = __webpack_require__(240);
	
	var _deskNav2 = _interopRequireDefault(_deskNav);
	
	var _windowDimensions = __webpack_require__(243);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.updateWindowDimensions = function () {
	      if (window) {
	        _this.setState({
	          width: window.innerWidth,
	          height: window.innerHeight
	        });
	      }
	    };
	
	    _this.state = {
	      width: '0',
	      height: '0',
	      currentPath: ''
	    };
	    return _this;
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    this.updateWindowDimensions();
	    if (window) {
	      window.addEventListener('resize', this.updateWindowDimensions);
	    }
	  };
	
	  Layout.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (window) {
	      window.removeEventListener('resize', this.updateWindowDimensions);
	    }
	  };
	
	  Layout.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: this.props.data.site.siteMetadata.title,
	          meta: [{ name: 'title', content: 'Daresay News' }, { name: 'description', content: '' }] },
	        _react2.default.createElement('meta', { charset: 'UTF-8' }),
	        _react2.default.createElement('meta', { itemprop: 'name', content: 'Daresay News' }),
	        _react2.default.createElement('meta', { itemprop: 'description', content: '' }),
	        _react2.default.createElement('meta', { itemprop: 'image', content: '' }),
	        _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' }),
	        _react2.default.createElement('meta', { name: 'twitter:title', content: 'Daresay News' }),
	        _react2.default.createElement('meta', { name: 'twitter:description', content: '' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Daresay News' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: '' }),
	        _react2.default.createElement('meta', { property: 'og:image:url', content: '' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: '' }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: '' }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: _favicon2.default }),
	        _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Libre+Franklin:300,600|Space+Mono:700', rel: 'stylesheet' }),
	        _react2.default.createElement('meta', { name: 'msapplication-TileColor', content: '#000000' }),
	        _react2.default.createElement('meta', { name: 'theme-color', content: '#ffffff' }),
	        _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1.0' })
	      ),
	      this.state.width < 800 ? _react2.default.createElement(_MobNav2.default, null) : _react2.default.createElement(_deskNav2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'mainContent col' },
	        this.props.children()
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.68f24be8.ico";

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.navData = undefined;
	
	var _imageExporter = __webpack_require__(83);
	
	var navData = exports.navData = [{
	  title: 'Daresay News',
	  image: _imageExporter.images.daresay_small,
	  href: '/'
	}, {
	  title: 'Transactions',
	  image: _imageExporter.images.transactions,
	  href: '/transactions'
	}, {
	  title: 'Connectivity',
	  image: _imageExporter.images.connectivity,
	  href: '/connectivity'
	}, {
	  title: 'Public Sector',
	  image: _imageExporter.images.public_sector,
	  href: '/publicsector'
	}, {
	  title: 'Health',
	  image: _imageExporter.images.health,
	  href: '/health'
	}];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6a3983d18c9b25f604c3.js